export default __webpack_public_path__ + "static/media/skill.35a14766.svg";